<template>
  <div class="form-input-complex">
    <el-row>
      <el-col :span="8" class="el-col--min-15em">
        <el-select
           v-model="select.value"
          :style="{ width: '22em' }"
          :placeholder="placeholder"
          :disabled="disabled"
          :clearable="clearable"
          @change="updateSelect">
          <el-option
             v-for="option in select.options"
            :label="option.name"
            :value="option.id"
            :key="option.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12" class="el-col--min-25em">
        <el-input
          v-model="simple.value"
          :placeholder="$t('label.comment')"
          :disabled="disabled"
          @change="updateSimple">
        </el-input>
      </el-col>
      <el-col :span="24" v-if="input.description">
        <div class="el-form-item__help">
          <p>{{ input.description }}</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { first, isNil } from 'lodash';

export default {
  name: 'form-input-complex',
  props: {
    input: {
      type: Object,
      required: true,
      default: null,
    },
    value: {
      required: true,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      select: {
        id: null,
        code: null,
        options: null,
        value: null,
      },
      simple: {
        id: null,
        code: null,
        value: null,
      },
    };
  },
  methods: {
    updateSimple() {
      this.$emit('set:value', {
        code: this.simple.code,
        data: {
          id: this.simple.id,
          value: this.simple.value,
        },
      });
    },
    updateSelect() {
      this.$emit('set:value', {
        code: this.select.code,
        data: {
          id: this.select.id,
          value: this.select.value,
        },
      });
    },
  },
  created() {
    const select = this.input.SubCategories.find(item => item.field_type === 'select');
    const simple = this.input.SubCategories.find(item => item.field_type === 'simple');

    if (!isNil(select)) {
      this.select.id = select.id;
      this.select.code = select.code;
      this.select.options = select.SubCategories;
      this.select.value = first(select.selected);
      this.updateSelect();
    }

    if (!isNil(simple)) {
      this.simple.id = simple.id;
      this.simple.code = simple.code;
      this.simple.value = simple.value;
      this.updateSimple();
    }
  },
};
</script>

<style lang="scss" scoped>
  .form-input-complex >>> .el-row {
    margin-bottom: 0.75em;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/consultation/form-input/cmpt-form-input-complex.vue